import Avatar1 from '../../assets/testi1.png';
import Avatar2 from '../../assets/testi2.png';
import Avatar3 from '../../assets/testi3.png';
import Avatar4 from '../../assets/testi4.png';
import Avatar5 from '../../assets/testi5.png';

const data = [
  {
    id: 1,
    avatar: Avatar1,
    name: 'Andhika Iswardana',
    status: '"Baru aja ganti LCD iPhone XS. pelayanan juga oke, harga terjangkau. Worth it deh buat yang lagi cari tempat servis yang bisa diandalkan!"',
  },
  {
    id: 2,
    avatar: Avatar2,
    name: 'Devi Nisa',
    status: '"ga nyesel jauh jauh kesini buat benerin iPhone ku yg gatau kenapa tbtb matii, pelayanannya ramah pol, bisa ditunggu jugaa, mantep si ini"',
  },
  {
    id: 3,
    avatar: Avatar3,
    name: 'David Yuliana Sari',
    status: '"for the first time, harga lumayan terjangkau dan yang paling penting part nya selalu ready. ada berbagai macam kualitas mereka ada"',
  },
  {
    id: 4,
    avatar: Avatar4,
    name: 'occydwiky',
    status: '"Pelayanan super cepat, tempat nyaman banget, dan mereka selalu punya sparepart yang ready dengan harga yang terjangkau! Suka banget!"',
  },
  {
    id: 5,
    avatar: Avatar5,
    name: 'Rizal Firmansyah',
    status: '"Pelayanan ramah banget, tempatnya nyaman, harga bersaing banget deh. Kerjain langsung di depan mata kita, mantap pokoknya!"',
  },
];

export default data;
